let duplicateCheck = "";

const state = () => ({
  queue: [],
  currentPlaying: "",
});

const mutations = {
  addToQueue(state, payload) {
    state.queue.push(payload);
  },
  scheduleGetItemAnimation(state, content) {
    state.queue.push({
      key: `getItem-${content.table}-${content.level}`
    });
  },
  removeFromQueue(state, payload) {
    state.queue.filter((item) => item !== payload);
  },
  setCurrentPlaying(state, payload) {
    state.currentPlaying = payload;
  },
  clear(state) {
    state.queue = [];
    state.currentPlaying = "";
  },
};

const actions = {
  startPlaying({ state, commit }) {
    if (state.queue.length === 0) {
      return;
    }

    const item = state.queue[0];

    duplicateCheck = item.key;
    commit("setCurrentPlaying", item.key);
  },
  next({ state, commit }, checkKey) {
    console.log("next", duplicateCheck, checkKey);
    if (state.queue.length === 0 || duplicateCheck !== checkKey) {
      return;
    }

    state.queue.shift();
    const item = state.queue[0];

    if (item) {
      duplicateCheck = item.key;
      commit("setCurrentPlaying", item.key);
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};